import React from 'react';
import PropTypes from 'prop-types';

import { Translate } from '@hydra/common/components';
import { Criterium, CriteriumIconAndText } from '@hydra/common/criterium';

export const MobileViewport = ({ criterium }) => {
  const { data, url } = criterium;

  const isPresent = data.isPresent || false;
  const isValid = data.isValid || false;
  const contentIsSizedToViewport = data.contentIsSizedToViewport || false;

  const items = [
    {
      name: 'configured',
      success: isPresent && isValid,
      content: <Translate content={`mobile_viewport_configured_${isPresent && isValid ? 'ok' : 'ko'}`} />
    },
    {
      name: 'size',
      success: contentIsSizedToViewport,
      content: <Translate content={`mobile_viewport_size_${contentIsSizedToViewport ? 'ok' : 'ko'}`} />
    }
  ];

  const content = (
    <>
      {
        items.map(item => (
          <CriteriumIconAndText key={item.name} success={item.success} text={item.content} />
        ))
      }
    </>
  );

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url }}
    >
      {content}
    </Criterium>
  );
};

MobileViewport.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      isPresent: PropTypes.bool.isRequired,
      isValid: PropTypes.bool.isRequired,
      contentIsSizedToViewport: PropTypes.bool.isRequired
    })
  })
};

export default React.memo(MobileViewport);
